import { useTranslation } from "react-i18next";
import { App, Flex } from "antd";
import { useNavigate } from "react-router-dom";

import { useUpdateSurveyAssignmentMutation } from "@/redux/service.js";
import BaseModal from "@/components_v2/Modal/BaseModal";
import BaseButton from "@/components_v2/Button/BaseButton";
import BaseSpinner from "@/components_v2/Spiner/BaseSpinner";
import { BUTTON_VARIANTS } from "@/components_v2/Button/constants";
import { SubmissionConfirmationModalProps } from "@/domains/survey/types";

const SubmissionConfirmationModal = ({
  open,
  setOpen,
  survey,
}: SubmissionConfirmationModalProps) => {
  const { t } = useTranslation();
  const { notification } = App.useApp();
  const navigate = useNavigate();

  const [submitSurvey, submitSurveyResponse] =
    useUpdateSurveyAssignmentMutation();

  const onCancel = () => setOpen(false);

  const handleSubmitSurvey = () => {
    submitSurvey({
      id: survey.details.id,
      data: { isSubmitted: true },
    })
      .unwrap()
      .then(() => {
        navigate(`/reports/${survey.details.id}/submission-success`);
      })
      .catch((error) =>
        notification.error({ message: error.data.errors[0].detail }),
      )
      .finally(onCancel);
  };

  return (
    <BaseModal
      open={open}
      title={t("survey.labels.confirmSubmission")}
      onCancel={onCancel}
      footer={
        <Flex wrap justify="end" align="center" gap={"small"}>
          <BaseButton
            key="cancel"
            variant={BUTTON_VARIANTS.TERTIARY}
            onClick={onCancel}
          >
            {t("survey.labels.cancel")}
          </BaseButton>

          <BaseButton
            key="confirm"
            onClick={handleSubmitSurvey}
            disabled={submitSurveyResponse.isLoading}
          >
            {submitSurveyResponse.isLoading && <BaseSpinner size="small" />}{" "}
            {t("survey.labels.submitReport")}
          </BaseButton>
        </Flex>
      }
    >
      {submitSurveyResponse.isLoading
        ? t("survey.labels.reportIsBeingSubmitted")
        : t("survey.labels.submitConfirmation")}
    </BaseModal>
  );
};

export default SubmissionConfirmationModal;
